export default {
  state: {
    rsvpReport: {
      show: false
    }
  },
  mutations: {
    setShowRsvpReport (state, value) { state.rsvpReport.show = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/reports/reports-rsvp.js